export default __webpack_public_path__ + "static/logo-blue-344e0eecd60b4811444edd4b4000c6dc.svg";